import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
const ExploreIcon: FC = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g clipPath="url(#clip0_706_3071)"><path d="M3 5.25H21" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" /><path d="M3 9.75H10.5" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" /><path d="M3 14.25H9" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" /><path d="M3 18.75H10.5" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" /><path d="M15.8247 17.25C17.4816 17.25 18.8247 15.9069 18.8247 14.25C18.8247 12.5931 17.4816 11.25 15.8247 11.25C14.1678 11.25 12.8247 12.5931 12.8247 14.25C12.8247 15.9069 14.1678 17.25 15.8247 17.25Z" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" /><path d="M17.94 16.365L20.415 18.84" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <>{t0}<defs><clipPath id="clip0_706_3071"><rect width="24" height="24" fill="white" /></clipPath></defs></>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default ExploreIcon;